import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import { TBiofouling2Place } from '../@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2H1Item1 = {
    locationWhereShipPerformanceLoss: string;
};

export type TBFL2H1Item2 = {
    inspectionOrBiofoulingMgmtActions: string;
};

export type TBFL2H1Item3 = {
    contingencyActions: string;
};

export type TBFL2H1Item4 = {
    datewhenShipReturnedToNormal: string;
};

export type TBFL2H1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2H1;
        item1: TBFL2H1Item1;
        item2: TBFL2H1Item2;
        item3: TBFL2H1Item3;
        item4: TBFL2H1Item4;
    };

export type TBFL2H = TBFL2H1;

const BFL2H_DEFAULTS: {
    H1: TBFL2H1;
} = {
    H1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            locationWhereShipPerformanceLoss: '',
        },
        item2: {
            inspectionOrBiofoulingMgmtActions: '',
        },
        item3: {
            contingencyActions: '',
        },
        item4: {
            datewhenShipReturnedToNormal: '',
        },
        recordCode: EBFL2RecordCode.BFL2H1,
    },
};

export { BFL2H_DEFAULTS };
